import { useEffect, useState } from 'react';
import styled from 'styled-components';

import SimpleHeader from '../../components/layout/SimpleHeader';
import Footer from '../../components/layout/Footer';
import PointSearch from '../../components/program/point/Search';
import PointTopButtons from '../../components/program/point/TopButtons';
import PointTable from '../../components/program/point/Table';
import PointTab2 from '../../components/program/point/Tab';
import { useLocation } from 'react-router-dom';
import QueryString from 'qs';
import { useTranslation } from 'react-i18next';
import useUtil from '../../hooks/useUtil';
import Split from 'react-split';

const Block = styled.div`
  .close-left {
    transform: translate(-33%);
  }

  .table-inside {
    width: 100%;

    th {
      background: ghostwhite;
    }
  }

  .table-basic th,
  td {
    vertical-align: middle;
  }

  h5 {
    margin-left: 5px;
    margin-bottom: 0;
  }

  .arrow {
    font-size: 26px;
    line-height: 26px;
  }

  .date {
    display: inline-block;
    width: 130px;
  }

  .rbc-event {
    text-align: center;
  }
`;

const ProgramPoint = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isCampusDeactived } = useUtil();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const [isExtended, setIsExtended] = useState(false);
  const [tab, setTab] = useState('pointSetting');
  const [refreshTable, setRefreshTable] = useState(false);
  const [campusDeactived, setCampusDeactived] = useState(false);

  useEffect(() => {
    if (query.tab) {
      setTab(String(query.tab));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    setCampusDeactived(isCampusDeactived());
  }, [isCampusDeactived]);

  return (
    <>
    <PointSearch tab={tab} />
    
    <Block className="content">
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={t('program.point.title1')}
        iconFile="icon-program-big.svg"
        onlyTitle={true}
      />

      <Split
        className='splite-divide'
        sizes={[30, 70]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        <div className='col-frame left_panel'>
          <PointTable setTab={setTab} refreshTable={refreshTable} />
        </div>
        <div className='col-frame right_panel'>
          <PointTab2/>
        </div>
      </Split>
    </Block>
    </>
  ); 
};

export default ProgramPoint;
